<!--<div class="publish-dialog">-->
<!--  <div class="header-container">-->
<!--    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>-->
<!--  </div>-->
<!--</div>-->

<h2 mat-dialog-title class="header">
  Story Preview
  <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</h2>

<mat-dialog-content class="mat-dialog-content">
  <div class="story-preview-container">
    <h3 class="story-preview-title">Story Preview</h3>
    <div class="story-preview-image">
      <span class="story-preview-image-text">
        Include a high-quality image in your story to make it more inviting to readers.
      </span>
    </div>
    <mat-form-field class="story-title-container">
      <mat-label>Title</mat-label>
      <input matInput class="story-title" [disabled]="true" [(ngModel)]="data.story.title" />
    </mat-form-field>
    <mat-form-field class="story-byline-container">
      <mat-label>Byline</mat-label>
      <input matInput class="story-byline" [(ngModel)]="data.story.byline" placeholder="Add story byline..." />
    </mat-form-field>
    <label><strong>Note:</strong> Changes here will affect how your story appears in public places like Anonymous Systems's homepage and in subscriber's inboxes — not the contents of the story itself.</label>
  </div>

  <div class="story-info-container">
    <span class="story-info-title">Publishing to: <strong>Anonymous Systems</strong></span>
    <label class="story-tags-label">Add or change tags (up to as many as you desire) so readers know what your story is about</label>
    <mat-form-field class="story-tag-container">
      <mat-label>Story Tags</mat-label>
      <mat-chip-grid #chipGrid aria-label="Tag selection">
        <mat-chip-row *ngFor="let tag of selectedStoryTags" (removed)="removeTag(tag)">
          {{tag}}
          <button matChipRemove [attr.aria-label]="'remove '+tag">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </mat-chip-grid>
      <input placeholder="New tag..."
             #tagInput
             [formControl]="tagControl"
             [matAutocomplete]="auto"
             [matChipInputFor]="chipGrid"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             (matChipInputTokenEnd)="addTag($event)">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let tag of autocompleteTags | async" [value]="tag">
          {{tag}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="story-category-container">
      <mat-label>Story Category</mat-label>
      <mat-select [formControl]="categoryControl" multiple>
        <mat-select-trigger>
          {{categoryControl.value ? categoryControl.value[0] : ''}}
          <span *ngIf="categoryControl.value?.length > 1">
              (+{{categoryControl.value.length - 1}} {{categoryControl.value?.length === 2 ? 'other' : 'others'}})
            </span>
        </mat-select-trigger>
        <mat-option *ngFor="let category of categories$ | async"
                    [value]="category.slug">
          {{category.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-button (click)="openCreateCategoryDialog()">Create New Category</button>

    <mat-form-field class="story-type">
      <mat-label>Story Type</mat-label>
      <mat-select [(value)]="data.story.type">
        <mat-option value="article">Article</mat-option>
        <mat-option value="blog">Blog</mat-option>
        <mat-option value="problem">Problem</mat-option>
        <mat-option value="snippet">Snippet</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="data.story.type === 'problem'">
      <div class="story-problem-status-container">
        <span class="">Open</span>
        <mat-slide-toggle [checked]="data.story.problemStatus === 'resolved'" (change)="data.story.problemStatus=$event.checked ? 'resolved' : 'open'">Resolved</mat-slide-toggle>
      </div>
    </ng-container>

    <div class="story-private-container">
      <span class="">Private</span>
      <mat-slide-toggle [checked]="data.story.visibility === 'public'" (change)="data.story.visibility=$event.checked ? 'public' : 'private'">Public</mat-slide-toggle>
      <p class="story-private-help-text">The story will only be visible to those given permission when private, which will not be listed on Anonymous System's homepage.</p>
    </div>

    <div class="story-comments-container">
      <mat-slide-toggle [checked]="data.story.allowComments" (change)="data.story.allowComments=$event.checked">Enable Comments</mat-slide-toggle>
      <p class="story-comments-help-text"></p>
    </div>

    <span class="learn-more"><a class="learn-more-link" [href]="nav_path.answersStories" target="_blank">Learn more</a> about what happens to your post when you publish.</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="saveAsDraft()">{{data.story.status === 'published' ? 'Save as draft' : 'Save'}}</button>
  <button mat-raised-button color="primary" (click)="publishStory()">{{data.story.status === 'published' ? 'Save' : 'Publish'}}</button>
  <button mat-button disabled>Schedule for later</button>
</mat-dialog-actions>
